import { ExternalBankAccount } from "@wingspanhq/wingspan-api-sdk";
import { selectorExternalBankAccountInstitution } from "./selectorExternalBankAccountInstitution";
import { selectorExternalBankAccountName } from "./selectorExternalBankAccountName";

export const selectorExternalBankAccountFullName = (
  externalBankAccount: ExternalBankAccount
): string => {
  const institution =
    selectorExternalBankAccountInstitution(externalBankAccount);
  const name = selectorExternalBankAccountName(externalBankAccount);

  if (!institution) {
    return name;
  }

  return `${institution} ${name}`;
};
